module.exports = __webpack_public_path__ + "static/img/10.364d3fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/web/10.jpg
// module id = eWF6
// module chunks = 4